import {Component, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-old-monthly-reports',
  templateUrl: './old-monthly-reports.component.html',
  styleUrls: ['./old-monthly-reports.component.scss']
})
export class OldMonthlyReportsComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
